/* import __COLOCATED_TEMPLATE__ from './parent-category-row.hbs'; */
import CategoryListItem from "discourse/components/category-list-item";
import TEMPLATE from "./parent-category-row.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, CategoryListItem.extend({}));